var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getPlayerStatus === 'playing')?_c('div',{staticClass:"lesson-text-container"},[_c('LessonDescription',{attrs:{"fromPlayer":_vm.fromPlayer}})],1):_c('LoadingPlayer')
}
var staticRenderFns = []

export { render, staticRenderFns }